<template>
  <div>
    <section-title
      class="mt-3"
      content="Datos del Informe de Referido"
      has-line
    />

    <div class="row my-3">
      <info-field
        class="col-3"
        label="Solicitante:"
        :value="model.requestedBy"
      />
      <info-field
        class="col-3"
        label="Rol en Sistema:"
        :value="model.systemRole"
      />
      <info-field
        class="col-3"
        format-type="date"
        label="Fecha de solicitud:"
        :value="model.requestDate"
      />
      <div v-if="isReadOnly" class="col-3 d-flex flex-column">
        <label class="text-muted">Fecha del informe:</label>
        <span>{{ model.reportDate | date }}</span>
      </div>
      <div v-else class="col-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            id="reportDate"
            v-model="model.reportDate"
            class-container="w-100"
            custom-error-msg="El campo es requerido."
            :disabled="isReadOnly"
            :error="errors[0]"
            label="Fecha del informe:"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-12 flex-column mt-3">
        <div class="color-secondary-6 font-14 mb-2">
          Fecha de Intervenciones:
        </div>
        <div
          v-for="item in model.interventionDates"
          :key="item.id"
          class="condition-pill mr-2 mb-2"
        >
          <span>{{ item | date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/shared/components/SectionTitle.vue';
import InfoField from './InfoField.vue';
import CustomDatePicker from 'custom-date-picker';

export default {
  name: 'ReferralReportSection',
  components: {
    SectionTitle,
    InfoField,
    CustomDatePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    validationErrors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    errorMap() {
      return (this.validationErrors || []).reduce((acc, item) => {
        if (item?.field) {
          acc[item.field] = item.message;
        }
        return acc;
      }, {});
    },
  },
};
</script>
<style scoped lang="scss">
.condition-pill {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  border: 1px solid #161414;
  border-radius: 20px;
  background: #fff;
}
</style>
